import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type StaffInvoicesViewMode = 'table' | 'list' | 'cards' | 'grouped';

interface StaffInvoicesUiState {
  view: StaffInvoicesViewMode;
  setView: (view: StaffInvoicesViewMode) => void;
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const useStaffInvoicesUi = create<StaffInvoicesUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'finance.staff-invoices:ui',
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
